// extracted by mini-css-extract-plugin
module.exports = {"body":"SetupIntervalForRegistrationModal_body__24tRA","checkboxes":"SetupIntervalForRegistrationModal_checkboxes__IOOzJ"};